import {CreditCard} from 'lucide-react';
import {createLucideIcon} from '../create-lucide-icon';

export const PaymentsIcon = createLucideIcon(CreditCard, 'PaymentsIcon');
